import React from "react";
import { connect } from "react-redux";
import { logUI } from "../../api/andyliticsApi";
import { Typography, Icon, Card, Grid, LinkList, Notifier, LinkText } from "../ecosystem";
import { CircleButtonCard, CardLinkList, PageHeading } from "../ecosystem/mybswh";
import * as Tools from '../../helpers/Tools';
import * as d from "../../reducers/domainReducer";
import * as msgs from "../../constants/textConstants";

const ScheduleNow = (props) => {

    const handleTileClick = (tileName) => {
        logUI(`MBHWeb.UI.ScheduleNow.${tileName}.Clicked`, new Date(), Tools.getURLPath());
    }

    const { currentUser, hasMyChart, screenBreakPoint, isActiveFeature_AmbulatoryVideoVisit, isActiveFeature_SDCVideoVisit, isActiveFeature_EVisit,isActiveFeature_InHomeVaccine, isActiveFeatureAnyone_InHomeVaccine,isProxyUser } = props;

    const isMobile = ([msgs.XS_MOBILE, msgs.SM_MOBILE, msgs.MD_TABLET]).indexOf(screenBreakPoint) > -1 ? true : false;
    const headingType = isMobile ? "body-03" : "heading-04";
    const headingBold = isMobile ? true : false;

    const location = window.store.getState().locations;
    let locCityAndState = location && location.city && location.state ? location.city + ',' + location.state : "";
    const enableFluVaccineSchedulingWorkflow = props.serverData && props.serverData.enableFluVaccineSchedulingWorkflow;
    const hideMyChartFluVaccineSchedulingWorkflow = props.serverData && props.serverData.hideMyChartFluVaccineSchedulingWorkflow;
    return (
        <Grid className="body-content schedule-now-container">
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <PageHeading
                        heading="Schedule Now"
                        description="Book an appointment with your doctor, schedule a video visit, and more."
                    />
                    <Notifier icon="alert" className="banner-wrapper">
                        If this is an emergency, please contact <LinkText typographyType="body-02" color="$color-primary-a2" underline="mobile" href='tel:911'>911.</LinkText>
                    </Notifier>
                    <div className="row">
                        <div className="col-12 col-lg-6">
                            <CircleButtonCard
                                arrowIcon={{ colorStyle: "float" }}
                                cardIcon={{ name: "doctor", set: "brand" }}
                                titleStyle={{ bold: headingBold, type: headingType }}
                                to={"/schedulingFor"}
                                disabled={!hasMyChart}
                                onClick={() => { handleTileClick("SeeYourDoctor"); }}
                                title="See Your Doctor"
                                body="Book with one of your current doctors"
                            />
                            <CardLinkList
                                cardIcon={{ name: 'schedule' }}
                                title="Schedule a Service"
                                body="Screening Mammography and vaccines"
                                list={[
                                    {
                                        text: "Screening Mammography",
                                        to: `/findcare?distance=25&vector=clinicalTerm&keyword=Screening%20Mammogram&location=${locCityAndState}&tab=2`,
                                        onClick: (e) => { logUI("MBHWeb.UI.ScheduleNow.ScreeningMammography.Clicked", new Date(), Tools.getURLPath()); }
                                    },
                                    hideMyChartFluVaccineSchedulingWorkflow && {
                                        text: "Flu Vaccine",
                                        to: enableFluVaccineSchedulingWorkflow ? `/findcare?distance=25&vector=clinicalTerm&keyword=Flu%20Vaccine&location=${locCityAndState}&tab=2` : `/scheduling/procedure/2101011111`,
                                        // to: "/scheduling/procedure/2101011111",
                                        onClick: (e) => { logUI("MBHWeb.UI.ScheduleNow.FluVaccine.Clicked", new Date(), Tools.getURLPath()); },
                                        disabled: !hasMyChart,
                                    },
                                    {
                                        text: "COVID-19 Vaccines",
                                        to: "/vaccineeligibility",
                                        onClick: (e) => { logUI("MBHWeb.UI.ScheduleNow.CovidVaccine.Clicked", new Date(), Tools.getURLPath(), { "externalId": currentUser && currentUser.externalId ? currentUser.externalId : "" }); },
                                        disabled: !hasMyChart,
                                    },
                                ].filter(Boolean)}
                            />
                            <CircleButtonCard
                                arrowIcon={{ colorStyle: "float" }}
                                cardIcon={{ name: "covid-19-vaccine", set: "brand" }}
                                titleStyle={{ bold: headingBold, type: headingType }}
                                to={"/inhomevaccine"}
                                /*disabled={!isActiveFeature_InHomeVaccine || (isProxyUser && !isActiveFeatureAnyone_InHomeVaccine)}*/
                                onClick={() => { handleTileClick("InHomeVaccines") }}
                                title="In-Home Vaccines"
                                body="Get vaccinated from the comfort of home. Healthcare, your way."
                            />
                        </div>
                        <div className="col-12 col-lg-6">
                            <CircleButtonCard
                                arrowIcon={{ colorStyle: "float" }}
                                cardIcon={{ name: "video-visit", set: "brand" }}
                                titleStyle={{ bold: headingBold, type: headingType }}
                                disabled={!hasMyChart || !(isActiveFeature_AmbulatoryVideoVisit || isActiveFeature_SDCVideoVisit)}
                                to={"/videovisitscheduledfor"}
                                onClick={() => { handleTileClick("VideoVisit"); }}
                                title="Video Visit"
                                body="Get care via camera-enabled device"
                            />
                            <CircleButtonCard
                                arrowIcon={{ colorStyle: "float" }}
                                cardIcon={{ name: "evisit", set: "brand" }}
                                titleStyle={{ bold: headingBold, type: headingType }}
                                to={"/evisit"}
                                disabled={!hasMyChart || !isActiveFeature_EVisit}
                                onClick={() => { handleTileClick("EVisit") }}
                                title="eVisit"
                                body="Answer questions for a diagnosis"
                            />
                        </div>

                    </div>
                </div>
            </div>
        </Grid>
    )
}
const mapStateToProps = (state) => {
    return {
        currentUser: d.hydrateProxyUser(state.domain.cu),
        hasMyChart: state.domain.hm,
        screenBreakPoint: state.common.screenBreakPoint,
        isActiveFeature_AmbulatoryVideoVisit: state.memberships.isActiveFeature_AmbulatoryVideoVisit,
        isActiveFeature_SDCVideoVisit: state.memberships.isActiveFeature_SDCVideoVisit,
        isActiveFeature_EVisit: state.memberships.isActiveFeature_EVisit,
        serverData: state.session.serverData,
        isActiveFeature_InHomeVaccine: state.memberships.isActiveFeature_InHomeVaccine,        
        isActiveFeatureAnyone_InHomeVaccine: state.memberships.isActiveFeatureAnyone_InHomeVaccine,
        isProxyUser: state.domain.ip  
    }
}
const mapDispatchToProps = (dispatch) => {
    return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(ScheduleNow);